import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { IWizardForm } from './wizard-form.component';
import { ISession } from '../../../models/session';

const privacySubscription = new BehaviorSubject<string>('public');
const accountTypeSubscription = new BehaviorSubject<string>('free');
const sessionTypeSubscription = new BehaviorSubject<string>('video');
const modelIdSubscription = new BehaviorSubject<string>('');
const registrationFormSubscription = new BehaviorSubject<IWizardForm>({
  fields: [],
  subscription: null,
  title: ''
});
const uniqueLoginSubscription = new BehaviorSubject<any>({});

const sessionSubscription = new BehaviorSubject<ISession>({
  date: new Date(),
  expirationdatetime: new Date(),
  id: '',
  name: '',
  speaker: '',
  description: '',
  data: {},
  status: 'STOPPED',
  language: '',
  urls: [],
  url: '',
  shortId: '',
  types: {
    privacy: '',
    accountType: '',
    sessionType: ''
  },
  topics: []
});

@Injectable()
export class WizardService {
  clean() {
    privacySubscription.complete();
    accountTypeSubscription.complete();
    sessionTypeSubscription.complete();
    modelIdSubscription.complete();
    registrationFormSubscription.complete();
    uniqueLoginSubscription.complete();
    sessionSubscription.complete();
  }

  getPrivacySubscription = () => privacySubscription;
  privacy$ = privacySubscription.asObservable();

  getAccountTypeSubscription = () => accountTypeSubscription;
  accountType$ = accountTypeSubscription.asObservable();

  getSessionTypeSubscription = () => sessionTypeSubscription;
  sessionType$ = sessionTypeSubscription.asObservable();

  getModelIdSubscription = () => modelIdSubscription;
  modelId$ = modelIdSubscription.asObservable();

  registrationForm$ = registrationFormSubscription.asObservable();
  getRegistrationFormSubscription = () => registrationFormSubscription;

  updateRegistrationForm = (form: IWizardForm) => registrationFormSubscription.next(form);

  session$ = sessionSubscription.asObservable();
  getSessionSubscription = () => sessionSubscription;

  uniqueLogin$ = uniqueLoginSubscription.asObservable();
  getUniqueLoginSubscription = () => uniqueLoginSubscription;
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/wizard/wizard.service.ts